/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */

(function (define) {
  'use strict';

  define(function () {
    return function progress(Promise) {
      /**
       * @deprecated
       * Register a progress handler for this promise
       * @param {function} onProgress
       * @returns {Promise}
       */
      Promise.prototype.progress = function (onProgress) {
        return this.then(void 0, void 0, onProgress);
      };
      return Promise;
    };
  });
})(typeof define === 'function' && define.amd ? define : function (factory) {
  module.exports = factory();
});